(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ml-campaign-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ml-campaign-carousel')) {
  customElements.define('ml-campaign-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mb-carousel-track');
      this.slides = [...this.querySelectorAll('[data-campaign-slide]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.active = 0;
      this.fitHeight = () => { this.track.style.height = `${Math.ceil(Math.max(...this.slides.map(slide => slide.getBoundingClientRect().height)))}px`; };
      this.resizeObserver = new ResizeObserver(this.fitHeight);
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      this.fitHeight();
      this.goTo = index => {
        index = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({left:this.slides[index].offsetLeft - this.slides[0].offsetLeft,behavior:this.motion.matches ? 'instant' : 'smooth'});
      };
      this.onKeydown = event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.active + (event.key === 'ArrowRight' ? 1 : -1));
      };
      this.onMotionChange = () => { this.paused = this.motion.matches; };
      this.addEventListener('keydown', this.onKeydown);
      this.motion.addEventListener('change',this.onMotionChange);
      this.timer = setInterval(() => {
        const bounds = this.getBoundingClientRect();
        if (this.paused || document.hidden || this.contains(document.activeElement) || (matchMedia('(hover:hover)').matches && this.matches(':hover')) || bounds.bottom <= 0 || bounds.top >= innerHeight) return;
        this.goTo(this.active + 1);
      },5000);
      this.onScroll = () => {
        const index = Math.max(0,Math.min(this.slides.length - 1,Math.round(this.track.scrollLeft / this.track.clientWidth)));
        if (index !== this.active) {
          this.active = index;
          this.fitHeight();
        }
      };
      this.track.addEventListener('scroll',this.onScroll,{passive:true});
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll',this.onScroll);
      this.resizeObserver?.disconnect();
      this.removeEventListener('keydown',this.onKeydown);
      this.motion?.removeEventListener('change',this.onMotionChange);
      clearInterval(this.timer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ml-product-card"] && !Shopify.designMode) return;
  try {
    function loadReviewedHoverPhoto(event) {
  if (event.type === 'pointerover' && event.pointerType === 'touch') return;
  const card = event.target.closest('.ml-product-card');
  const image = card?.querySelector('[data-hover-src]');
  if (!image || image.hasAttribute('src')) return;
  image.srcset = image.dataset.hoverSrcset;
  image.src = image.dataset.hoverSrc;
}
document.addEventListener('pointerover', loadReviewedHoverPhoto, { passive: true });
document.addEventListener('focusin', loadReviewedHoverPhoto);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ml-product-shelf"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ml-product-shelf')) {
  customElements.define('ml-product-shelf',class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mb-shelf-track');
      this.prev = this.querySelector('[data-shelf-direction="-1"]');
      this.next = this.querySelector('[data-shelf-direction="1"]');
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        this.prev.hidden = this.next.hidden = max < 2;
      };
      this.move = direction => {
        const card = this.track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        const page = Math.max(1,Math.floor((this.track.clientWidth + 1)/step));
        this.track.scrollTo({left:this.track.scrollLeft + direction * step * page,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      };
      this.click = event => {
        const button = event.target.closest('[data-shelf-direction]');
        if (button && this.contains(button)) this.move(Number(button.dataset.shelfDirection));
      };
      this.keydown = event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      };
      this.addEventListener('click',this.click);
      this.addEventListener('keydown',this.keydown);
      this.track.addEventListener('scroll',this.update,{passive:true});
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.track?.removeEventListener('scroll',this.update);
      this.removeEventListener('click',this.click);
      this.removeEventListener('keydown',this.keydown);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ml-taxonomy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){
  const form=event.target;
  if(form.id!=='ml-taxonomy')return;
  event.preventDefault();
  const tags=Array.from(form.querySelectorAll('select')).map(select=>select.value).filter(Boolean);
  const url=new URL(form.action);
  if(tags.length)url.pathname+='/'+tags.join('+');
  const params=new URLSearchParams(location.search);
  params.delete('page');
  url.search=params.toString();
  location.assign(url.href);
});
  } catch(e) { console.error(e); }
})();

})();
